import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { provideRouter, RouterLink, RouterOutlet } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { CategoryCardComponent } from './userComponents/category-card/category-card.component';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FormsModule } from '@angular/forms';
import { LanguageService } from './Services/language.service';
import { MenuLayoutComponent } from './layout-components/menu-layout/menu-layout.component';
import { adminModule } from './admin.module';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { IntroComponent } from './userComponents/intro/intro.component';
import { PageIntroComponent } from './pagesUser/page-intro/page-intro.component';
import { LanguageOptionComponent } from './userComponents/language-option/language-option.component';
import { PageLanguagesComponent } from './pagesUser/page-languages/page-languages.component';
import { HeaderComponent } from './userComponents/header/header.component';
import { PageMenuItemsUserComponent } from './pagesUser/page-menu-items-user/page-menu-items-user.component';
import { PageTitleGoldComponent } from './userComponents/page-title-gold/page-title-gold.component';
import { CategoriesScrollerComponent } from './userComponents/categories-scroller/categories-scroller.component';
import { PageSingleMenuItemUserComponent } from './pagesUser/page-single-menu-item-user/page-single-menu-item-user.component';
import { SingleItemCardComponent } from './userComponents/single-item-card/single-item-card.component';
import { GoldLineComponent } from './userComponents/gold-line/gold-line.component';
import { PriceUserComponent } from './userComponents/price-user/price-user.component';
import { CounterComponent } from './userComponents/counter/counter.component';
import { MenuFooterComponent } from './userComponents/menu-footer/menu-footer.component';
import { CuponComponent } from './userComponents/cupon/cupon.component';
import { CategoryTitleComponent } from "./userComponents/category-title/category-title.component";
import { LearnMoreComponent } from "./userComponents/learn-more/learn-more.component";
import { CartCardComponent } from "./userComponents/cart-card/cart-card.component";
import { OrderPageComponent } from './pagesUser/order-page/order-page.component';
import { PageCategoriesComponent } from './pagesUser/page-categories/page-categories.component';
import { MenuItemCardComponent } from './userComponents/menu-item-card/menu-item-card.component';
import { OrderListButtonComponent } from './userComponents/order-list-button/order-list-button.component';
import { BackButtonComponent } from './userComponents/back-button/back-button.component';
import { LanguageDropdownComponent } from './userComponents/language-dropdown/language-dropdown.component';
import { ScrollingModule } from '@angular/cdk/scrolling';


@NgModule({
  declarations: [
    AppComponent,
    CategoryCardComponent,
    MenuLayoutComponent,
    IntroComponent,
    PageIntroComponent,
    LanguageOptionComponent,
    PageLanguagesComponent,
    HeaderComponent,
    PageMenuItemsUserComponent,
    PageTitleGoldComponent,
    CategoriesScrollerComponent,
    PageSingleMenuItemUserComponent,
    SingleItemCardComponent,
    GoldLineComponent,
    PriceUserComponent,
    CounterComponent,
    MenuFooterComponent,
    CuponComponent,
    CartCardComponent,
    OrderPageComponent,
    PageCategoriesComponent,
    MenuItemCardComponent,
    PageMenuItemsUserComponent,
    OrderListButtonComponent,
    BackButtonComponent,
    LanguageDropdownComponent

    
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    RouterOutlet,
    BrowserModule,
    CdkDrag,
    FormsModule,
    RouterLink,
    adminModule,
    ZXingScannerModule,
    CategoryTitleComponent,
    LearnMoreComponent,
    ScrollingModule
],
  providers: [
    provideHttpClient(),
    provideRouter(routes),
    provideAnimationsAsync(),
    LanguageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: authInterceptor,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
